import React, { useState, useEffect } from "react";
import "./Products.css";
import ProductLoop from "./components/ProductLoop";
import ProductFilters from "./components/ProductFilters";
import PerPage from "./components/facets/PerPage";
import Pagination from "./components/Pagination";
import Loader from "./components/Loader";
import { useNavigate } from "react-router-dom";

// let allFilters = "";
function Products() {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [totalProducts, setTotalProducts] = useState(0);
  const wpProductFilter = window.wpProductFilter;
  const wpProductCategory = window.wpProductCategory;
  const siteInfo = window.wpProductFilter?.siteInfo;
  const plpPageLayout = siteInfo?.plpPageLayout;
  const catColor = wpProductCategory?.color_facet?.toLowerCase() ?? "";
  const catBrandFacet = wpProductCategory?.brand_facet?.toLowerCase() ?? "";
  const catSubBrandFacet = wpProductCategory?.sub_brand?.toLowerCase() ?? "";
  const catSubTypeFacet = wpProductCategory?.sub_type?.toLowerCase() ?? "";
  const catCollectionFacet =
    wpProductCategory?.collection_facet?.toLowerCase() ?? "";
  const catStyleFacet = wpProductCategory?.style_facet?.toLowerCase() ?? "";
  const catShadeFacet = wpProductCategory?.shade_facet?.toLowerCase() ?? "";
  const catShapeFacet = wpProductCategory?.shape_facet?.toLowerCase() ?? "";
  const catSkipShapeFacet =
    wpProductCategory?.skip_shape_facet?.toLowerCase() ?? "";

  const catFiberFacet = wpProductCategory?.fiber?.toLowerCase() ?? "";
  const catMaterialFacet =
    wpProductCategory?.material_facet?.toLowerCase() ?? "";
  const catMaterial = wpProductCategory?.material?.toLowerCase() ?? "";
  const catCustom = wpProductCategory?.custom?.toLowerCase() ?? "";

  const shortcodeLoadFacets = {
    color_facet: catColor,
    brand_facet: catBrandFacet,
    sub_brand: catSubBrandFacet,
    collection_facet: catCollectionFacet,
    style_facet: catStyleFacet,
    shade_facet: catShadeFacet,
    shape_facet: catShapeFacet,
    skip_shape_facet: catSkipShapeFacet,
    fiber: catFiberFacet,
    material: catMaterial,
    material_facet: catMaterialFacet,
    custom: catCustom,
    sub_type: catSubTypeFacet,
  };

  let shortcodeFacets = Object.fromEntries(
    Object.entries(shortcodeLoadFacets).filter(([_, v]) => v != ""),
  );

  const queryParams = new URLSearchParams(window.location.search);

  const paramColor = queryParams.get("color_facet")?.toLowerCase() ?? "";
  const paramBrandFacet = queryParams.get("brand_facet")?.toLowerCase() ?? "";
  const paramSubBrandFacet = queryParams.get("sub_brand")?.toLowerCase() ?? "";
  const paramSubTypeFacet = queryParams.get("sub_type")?.toLowerCase() ?? "";
  const paramCollectionFacet =
    queryParams.get("collection_facet")?.toLowerCase() ?? "";
  const paramApplicationFacet =
    queryParams.get("application_facet")?.toLowerCase() ?? "";
  const paramVariationFacet =
    queryParams.get("color_variation_facet")?.toLowerCase() ?? "";
  const paramConstructionFacet =
    queryParams.get("construction_facet")?.toLowerCase() ?? "";
  const paramInstallationFacet =
    queryParams.get("installation_facet")?.toLowerCase() ?? "";
  const paramLocationFacet =
    queryParams.get("location_facet")?.toLowerCase() ?? "";
  const paramSpeciesFacet =
    queryParams.get("species_facet")?.toLowerCase() ?? "";
  const paramTextureFacet =
    queryParams.get("surface_texture_facet")?.toLowerCase() ?? "";
  const paramStyleFacet = queryParams.get("style_facet")?.toLowerCase() ?? "";
  const paramShadeFacet = queryParams.get("shade_facet")?.toLowerCase() ?? "";
  const paramShapeFacet = queryParams.get("shape_facet")?.toLowerCase() ?? "";
  const paramLookFacet = queryParams.get("look_facet")?.toLowerCase() ?? "";
  const paramMaterial = queryParams.get("material")?.toLowerCase() ?? "";
  const paramMaterialFacet =
    queryParams.get("material_facet")?.toLowerCase() ?? "";
  const paramFiberFacet = queryParams.get("fiber")?.toLowerCase() ?? "";
  const paramBackingFacet =
    queryParams.get("backing_facet")?.toLowerCase() ?? "";
  const paramThicknessFacet =
    queryParams.get("thickness_facet")?.toLowerCase() ?? "";
  const paramWearLayerThicknessFacet =
    queryParams.get("wear_layer_thickness_facet")?.toLowerCase() ?? "";
  const paramHeight = queryParams.get("height")?.toLowerCase() ?? "";
  const paramWidth = queryParams.get("width")?.toLowerCase() ?? "";

  const paramSampleFacet =
    queryParams.get("samples_available_facets")?.toLowerCase() ?? "";
  const paramGroupFacet = queryParams.get("group")?.toLowerCase() ?? "";
  const paramSizeFacet = queryParams.get("size_facet")?.toLowerCase() ?? "";
  const paramPriceFacet = queryParams.get("price_facet")?.toLowerCase() ?? "";
  const paramCustomFacet = queryParams.get("custom")?.toLowerCase() ?? "";
  const filterObj = {
    color_facet: paramColor ? paramColor : catColor,
    brand_facet: paramBrandFacet ? paramBrandFacet : catBrandFacet,
    sub_brand: paramSubBrandFacet ? paramSubBrandFacet : catSubBrandFacet,

    collection_facet: paramCollectionFacet
      ? paramCollectionFacet
      : catCollectionFacet,
    application_facet: paramApplicationFacet,
    color_variation_facet: paramVariationFacet,
    construction_facet: paramConstructionFacet,
    installation_facet: paramInstallationFacet,
    location_facet: paramLocationFacet,
    species_facet: paramSpeciesFacet,
    surface_texture_facet: paramTextureFacet,
    style_facet: paramStyleFacet ? paramStyleFacet : catStyleFacet,
    shade_facet: paramShadeFacet ? paramShadeFacet : catShadeFacet,
    shape_facet: paramShapeFacet ? paramShapeFacet : catShapeFacet,
    skip_shape_facet: catSkipShapeFacet,
    look_facet: paramLookFacet,
    material: paramMaterial ? paramMaterial : catMaterial,
    material_facet: paramMaterialFacet ? paramMaterialFacet : catMaterialFacet,
    fiber: paramFiberFacet ? paramFiberFacet : catFiberFacet,
    backing_facet: paramBackingFacet,
    thickness_facet: paramThicknessFacet,
    wear_layer_thickness_facet: paramWearLayerThicknessFacet,
    height: paramHeight,
    width: paramWidth,
    samples_available_facets: paramSampleFacet,
    group: paramGroupFacet,
    size_facet: paramSizeFacet,
    price_facet: paramPriceFacet,
    custom: paramCustomFacet ? paramCustomFacet : catCustom,
    sub_type: paramSubTypeFacet ? paramSubTypeFacet : catSubTypeFacet,
    search: queryParams.get("search")
      ? queryParams.get("search").toLowerCase()
      : "",
  };
  let filteredObj = Object.fromEntries(
    Object.entries(filterObj).filter(([_, v]) => v != ""),
  );

  const [filters, setFilters] = useState(filteredObj);

  const filterObj1 = {
    color_facet: paramColor,
    brand_facet: paramBrandFacet,
    sub_brand: paramSubBrandFacet,
    collection_facet: paramCollectionFacet,
    application_facet: paramApplicationFacet,
    color_variation_facet: paramVariationFacet,
    construction_facet: paramConstructionFacet,
    installation_facet: paramInstallationFacet,
    location_facet: paramLocationFacet,
    species_facet: paramSpeciesFacet,
    surface_texture_facet: paramTextureFacet,
    style_facet: paramStyleFacet,
    shade_facet: paramShadeFacet,
    shape_facet: paramShapeFacet,
    look_facet: paramLookFacet,
    material: paramMaterial,
    material_facet: paramMaterialFacet,
    fiber: paramFiberFacet,
    backing_facet: paramBackingFacet,
    thickness_facet: paramThicknessFacet,
    wear_layer_thickness_facet: paramWearLayerThicknessFacet,
    height: paramHeight,
    width: paramWidth,
    samples_available_facets: paramSampleFacet,
    group: paramGroupFacet,
    size_facet: paramSizeFacet,
    price_facet: paramPriceFacet,
    custom: paramCustomFacet,
    paged: queryParams.get("paged") ?? "",
    limit: queryParams.get("limit") ?? "",
    sub_type: paramSubTypeFacet,
    search: queryParams.get("search")?.toLowerCase() ?? "",
  };
  let filteredObj1 = Object.fromEntries(
    Object.entries(filterObj1).filter(([_, v]) => v != ""),
  );
  const [urlParams, setUrlParams] = useState(filteredObj1);
  // const [sort, setSort] = useState("");
  const paramPage = queryParams.get("paged") ? queryParams.get("paged") : 1;
  const [paged, setPage] = useState(paramPage);
  const [selectedCollection, setSelectedCollection] = useState([
    paramCollectionFacet ? paramCollectionFacet : catCollectionFacet,
  ]);
  const selectedSampleVal =
    paramSampleFacet == "Yes" || paramSampleFacet == "yes" ? "Yes" : "";
  const [selectedSample, setSelectedSample] = useState(selectedSampleVal);

  const [productCollections, setCollections] = useState({});
  const [productBrands, setBrands] = useState({});
  const [productSubBrands, setSubBrands] = useState({});
  const [productSubType, setSubType] = useState({});
  const [productColors, setColors] = useState({});
  const [productApplications, setApplications] = useState({});
  const [productConstructions, setConstruction] = useState({});
  const [productColorVariations, setColorVariation] = useState({});
  const [productInstallationMethods, setInstallationMethods] = useState({});
  const [productLocations, setLocations] = useState({});
  const [productSpecies, setSpecies] = useState({});
  const [productTextures, setTextures] = useState({});
  const [productStyle, setStyle] = useState({});
  const [productDesign, setDesign] = useState({});
  const [productShade, setShade] = useState({});
  const [productShape, setShape] = useState({});
  const [productLook, setLook] = useState({});
  const [productMaterialFacet, setMaterialFacet] = useState({});
  const [productMaterial, setMaterial] = useState({});
  const [productFiber, setFiber] = useState({});
  const [productBacking, setBacking] = useState({});
  const [productThickness, setThickness] = useState({});
  const [productWearLayerThickness, setWearLayerThickness] = useState({});
  const [productHeight, setHeight] = useState({});
  const [productWidth, setWidth] = useState({});
  const [productSamples, setSamples] = useState({});
  const [productGroup, setGroup] = useState({});
  const [productSize, setSize] = useState({});
  const [productPrice, setPrice] = useState({});
  const [productCustom, setCustom] = useState({});
  const [initialApplicationFacet, setInitialApplicationFacet] = useState({}); //new
  const [pageNumbers, setPageNumbers] = useState([]);

  const paramLimit = queryParams.get("limit") ? queryParams.get("limit") : 12;
  const [itemsPerPage, setItemsPerPage] = useState(paramLimit);

  const paramSearch = queryParams.get("search")
    ? queryParams.get("search").toLowerCase()
    : "";
  const [searchText, setSearchText] = useState(paramSearch);

  const inStock = wpProductCategory?.inStock ?? "";
  const plpTitle = wpProductCategory?.title ?? "";
  const plpSubTitle = wpProductCategory?.subtitle ?? "";
  const pageName = wpProductCategory?.page ?? "";

  let plpFacets = [];
  const plpFacetOrder = wpProductCategory?.plpFacetOrder;

  if (plpFacetOrder && Object.keys(plpFacetOrder)?.length > 0) {
    const backendFacets = wpProductCategory?.plpFacets ?? []; // new change
    // plpFacets = backendFacets
    //   .filter((facet) => plpFacetOrder.hasOwnProperty(facet))
    //   .sort((a, b) => Number(plpFacetOrder[a]) - Number(plpFacetOrder[b]));
    plpFacets = backendFacets.sort((a, b) => {
      const orderA = plpFacetOrder?.[a] ? Number(plpFacetOrder?.[a]) : Infinity;
      const orderB = plpFacetOrder?.[b] ? Number(plpFacetOrder?.[b]) : Infinity;
      return orderA - orderB;
    });
  } else {
    plpFacets = wpProductCategory?.plpFacets ?? [];
  }
  const plpFacetLabel = wpProductCategory?.plpFacetLabel;

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetchProducts();
  }, [filters, paged, itemsPerPage]);

  const fetchProducts = async () => {
    const query = new URLSearchParams({
      category: wpProductCategory?.category,
      ...filters,
      paged,
      limit: itemsPerPage,
      in_stock: inStock,
      pageName: pageName,
    });

    const query1 = new URLSearchParams({
      ...urlParams,
    });

    try {
      navigate("?" + query1.toString());
      const response = await fetch(`${wpProductFilter?.apiEndpoint}?${query}`);
      const data = await response.json();
      setProducts(data?.products_group_by);
      setTotalProducts(data?.total);
      populateFilters(data.filter_counts);
      // allFilters = allFilters !== "" ? allFilters : data.filter_counts;
      // populateMultiFilters(allFilters);
      calculatePagination(data.total, itemsPerPage, paged);
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setLoading(false);
    }
  };

  const [isOpen, setIsOpen] = useState(false);

  const toggleFlyer = () => {
    setIsOpen(!isOpen);
  };

  const populateFilters = (counts) => {
    setCollections(counts?.["collection_facet"]);
    setBrands(counts?.["brand_facet"]);
    setSubBrands(counts?.["sub_brand"]);
    setSubType(counts?.["sub_type"]);
    setColors(counts?.["color_facet"]);
    setApplications(counts?.["application_facet"]);
    setColorVariation(counts?.["color_variation_facet"]);
    setConstruction(counts?.["construction_facet"]);
    setInstallationMethods(counts?.["installation_facet"]);
    setLocations(counts?.["location_facet"]);
    setSpecies(counts?.["species_facet"]);
    setTextures(counts?.["surface_texture_facet"]);
    setStyle(counts?.["style_facet"]);
    setDesign(counts?.["design"]);
    setShade(counts?.["shade_facet"]);
    setShape(counts?.["shape_facet"]);
    setLook(counts?.["look_facet"]);
    setMaterialFacet(counts?.["material_facet"]);
    setMaterial(counts?.["material"]);
    setFiber(counts?.["fiber"]);
    setBacking(counts?.["backing_facet"]);
    setHeight(counts?.["height"]);
    setWidth(counts?.["width"]);
    setThickness(counts?.["thickness_facet"]);
    setWearLayerThickness(counts?.["wear_layer_thickness_facet"]);
    setSamples(counts?.["samples_available_facets"]);
    setGroup(counts?.["group"]);
    setSize(counts?.["size_facet"]);
    setPrice(counts?.["price_facet"]);
    setCustom(counts?.["custom"]);
    if (Object.keys(initialApplicationFacet).length === 0) {
      setInitialApplicationFacet(counts?.["application_facet"] || {}); //new
    }
  };

  const populateMultiFilters = (counts) => {
    // setCollections(counts["collection_facet"]);
    //  setApplications(counts["application_facet"]);
  };

  const handleCheckboxChange = (filterName, value) => {
    let filterList = selectedCollection;
    let collections = filterList[filterName] ? filterList[filterName] : [];
    collections.includes(value.toLowerCase())
      ? collections.splice(collections.indexOf(value.toLowerCase()), 1)
      : collections.push(value.toLowerCase());
    setSelectedCollection({
      ...filterList,
      [filterName]: collections,
    });
    collections = collections.join(",");
    setFilters({
      ...shortcodeFacets,
      ...filters,
      [filterName]: collections,
    });
    setPage(1);
    setUrlParams({
      ...urlParams,
      [filterName]: collections.toLowerCase(),
      paged: 1,
    });
  };

  const handleFilterChange = (filterName, value) => {
    setFilters({
      ...shortcodeFacets,
      ...filters,
      [filterName]: value.toLowerCase(),
    });
    if (filterName == "search") {
      setSearchText(value.toLowerCase());
    }
    setPage(1);
    setUrlParams({
      ...urlParams,
      [filterName]: value.toLowerCase(),
      paged: 1,
    });
  };
  const handleFilterClick = (filterName, value) => {
    const currentValues = filters[filterName]
      ? filters[filterName].split(",")
      : [];

    let updatedValues;
    if (filterName == "shape_facet") {
      updatedValues = [value];
    } else if (currentValues.includes(value.toLowerCase())) {
      updatedValues = currentValues.filter(
        (item) => item !== value.toLowerCase(),
      );
    } else {
      updatedValues = [...currentValues, value.toLowerCase()];
    }

    const joined = updatedValues.join(",");

    setFilters({
      ...filters,
      [filterName]: joined,
    });

    setPage(1);
    setUrlParams({
      ...urlParams,
      [filterName]: joined,
      paged: 1,
    });
  };

  const handleFilterSample = (filterName, value) => {
    setSelectedSample(value);
    setFilters({
      ...shortcodeFacets,
      ...filters,
      [filterName]: value == "" ? "" : value.toLowerCase(),
    });

    setPage(1);

    setUrlParams({
      ...urlParams,
      [filterName]: value == "" ? "" : value.toLowerCase(),
      paged: 1,
    });
  };

  const handleRemoveFilter = (filterName) => {
    const updatedObj = Object.fromEntries(
      Object.entries(filters).filter(([key]) => key !== filterName),
    );
    // let filterList = selectedCollection;
    // console.log(filterList);
    // if (filterList[filterName]) {
    //   filterList.splice(filterName, 1);
    //   setSelectedCollection({
    //     ...filterList,
    //   });
    // }

    setFilters({
      ...updatedObj,
      ...shortcodeFacets,
    });
    setPage(1);
    setUrlParams({
      ...updatedObj,
      ...shortcodeFacets,
      paged,
      limit: itemsPerPage,
    });
  };
  const handleResetFilter = () => {
    // allFilters = "";
    // setSelectedCollection({});
    setFilters({
      ...shortcodeFacets,
    });
    setSearchText("");
    setSelectedSample("");
    setPage(1);
    setUrlParams({});
  };
  const handlePerPage = (value) => {
    setItemsPerPage(value);
    // handleFilterChange("limit", value);
    setPage(1);
    setUrlParams({
      ...urlParams,
      limit: value,
    });
  };

  const handlePagination = (pageNo) => {
    setPage(pageNo.target.value);
    setUrlParams({
      ...urlParams,
      paged: pageNo.target.value,
    });
    var queryParams = new URLSearchParams(window.location.search);
    queryParams.set("paged", pageNo.target.value);
    window.location.href =
      window.location.origin +
      "" +
      window.location.pathname +
      "?" +
      queryParams.toString();
  };
  const calculatePagination = (totalProducts, itemsPerPage, page) => {
    const total_pages = Math.ceil(totalProducts / itemsPerPage);
    let start_page = 1;
    let end_page = total_pages;
    let numbers = [start_page, end_page];
    if (total_pages === 1) {
      numbers = [1];
    } else if (total_pages === 2) {
      numbers = [1, 2];
    } else if (total_pages === 3) {
      numbers = [1, 2, 3];
    } else if (page < 3 || page == end_page || page == end_page - 1) {
      numbers = [1, 2, 3, end_page - 2, end_page - 1, end_page];
    } else if (page >= 3 && page <= end_page - 2) {
      let current_page = page;
      numbers = [
        1,
        Number(current_page) - 1,
        current_page,
        Number(current_page) + 1,
        Number(current_page) + 2,
        end_page - 1,
        end_page,
      ];
    }

    setPageNumbers([...new Set(numbers)]);
  };
  const { sub_type, ...newFilters } = filters;
  const hasActiveFilters =
    Object.keys(newFilters).length > 1 ||
    !filters.hasOwnProperty("skip_shape_facet")
      ? Object.values(newFilters).some((value) => value !== "")
      : false;

  return (
    <>
      <div
        className={`product-list-container ${
          plpPageLayout === "normal"
            ? "normal_plp_layout"
            : "color_switch_plp_layout"
        }`}>
        {loading ? (
          <Loader />
        ) : (
          <div className="row">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-lg-3 col-md-3 col-sm-12">
                  <h4 className="fl-heading plp-heading" role="heading">
                    <span class="fl-heading-text">{plpTitle}</span>
                  </h4>
                  <h5 className="fl-heading plp-sub-heading" role="heading">
                    <span class="fl-heading-text">{plpSubTitle}</span>
                  </h5>
                </div>
                <div className="col-lg-9 col-md-9 col-sm-12 top-pager">
                  <div className="text-left">
                    {totalProducts > 0 ? totalProducts + " Results" : ""}
                  </div>
                  <div className="text-right">
                    <PerPage handlePerPage={handlePerPage} />
                  </div>
                </div>
              </div>
              <div className="row">
                <ProductFilters
                  isOpen={isOpen}
                  toggleFlyer={toggleFlyer}
                  plpFacetLabel={plpFacetLabel}
                  searchText={searchText}
                  handleFilterChange={handleFilterChange}
                  hasActiveFilters={hasActiveFilters}
                  handleResetFilter={handleResetFilter}
                  filters={filters}
                  handleRemoveFilter={handleRemoveFilter}
                  plpFacets={plpFacets}
                  productSamples={productSamples}
                  handleFilterSample={handleFilterSample}
                  selectedSample={selectedSample}
                  productBrands={productBrands}
                  handleFilterClick={handleFilterClick}
                  productSubBrands={productSubBrands}
                  productSubType={productSubType}
                  productCustom={productCustom}
                  productGroup={productGroup}
                  productSize={productSize}
                  productPrice={productPrice}
                  productCollections={productCollections}
                  handleCheckboxChange={handleCheckboxChange}
                  selectedCollection={selectedCollection}
                  productApplications={productApplications}
                  initialApplicationFacet={initialApplicationFacet}
                  productStyle={productStyle}
                  productColorVariations={productColorVariations}
                  productConstructions={productConstructions}
                  productColors={productColors}
                  productInstallationMethods={productInstallationMethods}
                  productLocations={productLocations}
                  productSpecies={productSpecies}
                  productLook={productLook}
                  productMaterial={productMaterial}
                  productMaterialFacet={productMaterialFacet}
                  productDesign={productDesign}
                  productFiber={productFiber}
                  productBacking={productBacking}
                  productTextures={productTextures}
                  productShade={productShade}
                  productShape={productShape}
                  productThickness={productThickness}
                  productWearLayerThickness={productWearLayerThickness}
                  productHeight={productHeight}
                  productWidth={productWidth}
                />
                {Object.keys(products).length > 0 && (
                  <div className="col-lg-9 col-md-9 col-sm-12">
                    <div className="row">
                      <div className="col-lg-12 col-md-12 col-sm-12 products-list ">
                        <div class="open_sidebar">
                          <a
                            class="fl-button"
                            onClick={toggleFlyer}
                            href="javascript:void(0)">
                            <span class="fl-button-text">Filter By</span>
                          </a>
                        </div>
                        <div className="product-plp-grid product-grid swatch facetwp-template1">
                          <div className="row product-row">
                            {Object.keys(products).map((product, i) => {
                              return (
                                <ProductLoop
                                  key={i}
                                  products={products[product]}
                                />
                              );
                            })}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12 col-sm-12 bottom-pager">
                        <div className="page-info">
                          <div className="pagination_wrapper">
                            <ul>
                              {pageNumbers.map((number) => {
                                return (
                                  <Pagination
                                    key={number}
                                    number={number}
                                    handlePagination={handlePagination}
                                    currentPage={paged}
                                  />
                                );
                              })}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {Object.keys(products).length == 0 && loading == false && (
                  <div className="col-lg-9 col-md-9 col-sm-12 product-list-container">
                    <div className="col-lg-12 col-md-12 col-sm-12 ">
                      <h2>No Products Available</h2>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default Products;
